/**
 * 認證、Token、Storage 相關常量
 */

// Storage 鍵名
export const STORAGE_USER_TOKEN = 'userToken';
export const STORAGE_REFRESH_TOKEN = 'refreshToken';
export const STORAGE_TOKEN_EXPIRES_AT = 'tokenExpiresAt';
export const STORAGE_USER_INFO = 'userInfo';
export const STORAGE_LANGUAGE = 'language';
export const STORAGE_THEME = 'theme';

// Token 時效常量
export const TOKEN_EXPIRY_TIME = 15 * 60 * 1000; // 15 分鐘（毫秒）
export const TOKEN_REFRESH_THRESHOLD = 2 * 60 * 1000; // 提前 2 分鐘刷新
